<app-right-side-drawer [show]="navService.showCenterLocation">
    <ng-template #contentHeader>

    </ng-template>
    <ng-template #content>
        <ng-container [ngTemplateOutlet]="CenterLocation"></ng-container>
    </ng-template>
</app-right-side-drawer>

<ng-template #CenterLocation>
    <!-- Dropdowns -->
    <div class="frame bottom-gap3">
        <div class="">
            <label class="label">Centers</label>
            <div class="dropdown-list-wrapper">
                <div class="dropdown-list">
                    <f-dropdown [filter]="true" placeholder="Select Center" [options]="centerList" optionLabel="Name"
                        optionValue="Code" [(ngModel)]="selectedCenterId" (ngModelChange)="onCenterChange($event)"
                        styleClass="search_filter__dropdown ">
                    </f-dropdown>
                </div>
            </div>
        </div>
        <div class="">
            <label class="label">Skills</label>
            <div class="dropdown-list-wrapper">
                <div class="dropdown-list">
                    <f-dropdown [filter]="true" placeholder="Select Skill" [options]="campaignList" optionLabel="Code"
                        optionValue="Id" [(ngModel)]="selectedCampaignId"
                        (ngModelChange)="onSelectedCampaignChange($event)" styleClass="search_filter__dropdown ">
                    </f-dropdown>
                </div>
            </div>
        </div>
        <div class="button-group-wrapper">
            <span class="changes" *ngIf="centerId != selectedCenterId || campaignId != selectedCampaignId">changes not saved</span>
            <div class="btns-group btns-group--actions-list">
                <a class="btns-group__btn btns-group__btn--with-border-tertiary" (click)="onCancel()">cancel</a>
                <a class="btns-group__btn btns-group__btn--with-border-quaternary" (click)="onSave()">Save</a>
            </div>
        </div>
    </div>
</ng-template>